import { useEffect, useState, useRef, useMemo } from 'react';
import { Modal, Input, message, Button, Space, Select } from 'antd';
import { difference } from 'lodash-es';
import './index.less';
import * as api from '@/services/enterprise';
import { toTree } from '@/utils/utils';
import ProjectApplication from '../projectApplication';

const { Option } = Select;

const CreateAuthorizationCode = (props: any) => {
  const {
    handleAuCodeOK,
    handleAuCodeCancel,
    setPurchaseNum,
    setDurationeNum,
    setOwnProjectApplications,
    comName,
    // defaultCheckedList,
    units,
  } = props;

  const [unit, setUnit] = useState('month');
  const codeNumRef = useRef<any>(null);

  // 获取授权码创建上限
  const [maxCount, setMaxCount] = useState(50);
  const getCodeCount = async () => {
    const res = await api.getCodeCount();
    // console.log('授权码创建上限', res);
    if (res.code === 200 && res.success) {
      setMaxCount(res.data.details);
    }
  };

  // 购买项目数量
  const [inputPurchaseStatus, setInputPurchaseStatus] = useState('null');
  const onInputPurchaseNum = (e: any) => {
    const num = Number(e.target.value);
    // console.log('输入', num);
    if (num > maxCount || num < 1 || isNaN(num) || num % 1 !== 0) {
      setInputPurchaseStatus('error');
    } else {
      setPurchaseNum(e.target.value);
      setInputPurchaseStatus('');
    }
  };

  const checkNum = (numberUnit: string, val: number) => {
    const isNotNum = isNaN(val) || val % 1 !== 0;
    const isInvidate =
      (numberUnit === 'month' && (val > 100 || val < 1)) ||
      (numberUnit === 'day' && (val > 365 || val < 1));
    // console.log(isNotNum, isInvidate, '====checkNum');
    return !isNotNum && !isInvidate;
    //数字 && 整数
  };

  // 设置有效期
  const [inputDurationStatus, setInputDurationStatus] = useState('null');
  const onInputDurationNum = (e: any) => {
    const num = Number(e.target?.value);
    // console.log('输入', e.target?.value, num);
    // if (num > 120 || num < 1 || isNaN(num) || num % 1 !== 0) {
    //   setInputDurationStatus('error');
    // } else {
    //   setDurationeNum(e.target.value);
    //   setInputDurationStatus('');
    // }
    const isValidate = checkNum(unit, num);
    // console.log(isValidate, '====isValidate');
    if (isValidate) {
      setDurationeNum(e.target.value);
      setInputDurationStatus('');
    } else {
      setInputDurationStatus('error');
    }
  };

  // 项目级应用
  // const defaultCheckedList = ['project'];
  // const plainOptions = [
  //   { label: '项目管理', value: 'project', disabled: true },
  //   { label: '模型协同', value: 'cloud_model' },
  //   { label: '审核决策', value: 'audit_decision' },
  //   { label: '数字营销', value: 'digital_marketing' },
  //   { label: '成本营销', value: 'digital_marketing_pad' },
  // ]; // 全部选项

  // const [plainOptions, setPlainOptions] = useState([]);
  const [projectApplicationTree, setProjectApplicationTree] = useState<any[]>([]);
  const [projectApplicationList, setrojectApplicationList] = useState<any[]>([]);

  const getPerList = async () => {
    const res = await api.getPermissionsList('2');
    // console.log('获取授权码权限列表', res);
    if (res.code === 200 && res.success) {
      const lists = res?.data?.details || [];
      setrojectApplicationList(lists);
      const newDatas = toTree(
        lists,
        {
          id: 'id',
          parentId: 'parentId',
        },
        (item: any) => {
          //项目管理 不可修改
          if (item?.code === 'project') {
            item.disabled = true;
          }
          //默认全选中
          item.checked = true;
          item.key = item.code;
        },
      );
      //默认选中项目管理
      const defaultCheckedList = lists?.map((l: any) => l?.code);
      setOwnProjectApplications(defaultCheckedList);
      setProjectApplicationTree(newDatas);
    } else {
      message.error('获取项目级权限列表失败');
    }
  };
  // const onOptionChange = (list: any) => {
  //   // console.log('点击选项', list);
  //   setOwnProjectApplications(list);
  // };

  useEffect(() => {
    // console.log('defaultCheckedList', defaultCheckedList);
    getCodeCount();
    getPerList();
    // setOwnProjectApplications(defaultCheckedList);
  }, []);

  const changeAddonAfter = (value: string) => {
    setUnit(value);
    const num = codeNumRef.current?.input?.value;
    if (num === undefined || num === '') {
      return;
    }
    const isValidate = checkNum(value, num);
    if (isValidate) {
      setInputDurationStatus('');
    } else {
      setInputDurationStatus('error');
    }
  };

  const addonAfter = (
    <Select value={unit} onChange={changeAddonAfter}>
      {units?.map((u: any) => (
        <Option value={u.code}>{u.name}</Option>
      ))}
    </Select>
  );

  const submitHandle = () => {
    handleAuCodeOK(unit);
  };

  return (
    <>
      <Modal
        title="创建授权码"
        visible={true}
        onOk={submitHandle}
        onCancel={handleAuCodeCancel}
        width={600}
        className="createAuthorizationCodeModal"
        footer={
          <Space>
            <Button onClick={handleAuCodeCancel}>取消</Button>
            <Button
              disabled={
                inputPurchaseStatus === 'error' ||
                inputPurchaseStatus === 'null' ||
                inputDurationStatus === 'error' ||
                inputDurationStatus === 'null'
              }
              type="primary"
              onClick={submitHandle}
            >
              确定
            </Button>
          </Space>
        }
      >
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            企业空间
          </div>
          <div className="modalInput" style={{ margin: 0 }}>
            <div style={{ lineHeight: 3.2, height: 40 }}>{comName}</div>
          </div>
        </div>
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            购买项目数量
          </div>
          <div className="modalInput" style={{ margin: 0, marginTop: '8px' }}>
            <Input
              placeholder="输入数量"
              onChange={onInputPurchaseNum}
              status={inputPurchaseStatus === 'error' ? inputPurchaseStatus : undefined}
              style={{ width: '120px' }}
            />
            {inputPurchaseStatus === 'error' ? (
              <div className="inputMention" style={{ color: '#ff4d4f', fontSize: '12px' }}>
                请输入1-{maxCount}的正整数
              </div>
            ) : null}
          </div>
        </div>
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            项目级应用
          </div>
          <div className="modalInput" style={{ margin: 0 }}>
            {/* <Checkbox.Group
              defaultValue={defaultCheckedList}
              onChange={onOptionChange}
              options={plainOptions}
            /> */}
            {projectApplicationTree?.map((tr, i) => (
              <ProjectApplication
                key={tr.code}
                datas={tr}
                index={i}
                setOwnProjectApplications={setOwnProjectApplications}
              ></ProjectApplication>
            ))}
          </div>
        </div>
        <div className="modalContent inputUserName">
          <div className="inputLabel" style={{ width: 84 }}>
            有效期
          </div>
          <div className="modalInput" style={{ margin: 0, marginTop: '8px' }}>
            <Input
              placeholder="输入数量"
              onChange={onInputDurationNum}
              addonAfter={addonAfter}
              status={inputDurationStatus === 'error' ? inputDurationStatus : undefined}
              style={{ width: '140px' }}
              className="modalCodeInput"
              ref={codeNumRef}
            />
            {inputDurationStatus === 'error' ? (
              <div className="inputMention" style={{ color: '#ff4d4f', fontSize: '12px' }}>
                {unit === 'month' ? '请输入1-100的正整数' : '请输入1-365的正整数'}
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateAuthorizationCode;
